export enum TermoDiretrizEnum {
    GestaoCargaHoraria = 1,
}

export const TermoDiretrizEnumLabel = new Map<TermoDiretrizEnum, string>([
    [TermoDiretrizEnum.GestaoCargaHoraria, "Gestão Carga Horária"],
]);
